import React, { Component } from 'react';
import moment from 'moment';

import NotificationItem from './NotificationItem';

const DEFAULT_TIMER_COUNTDOWN = 3;
const DEFAULT_TIME_STEP = 1000;

class NotificationWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countDown: 0,
      message: '',
      msgId: ''
    };
  };

  componentDidMount () {
    this.setState({
      countDown: 0,
      message: '',
      msgId: '',
    });
  }

  componentDidUpdate(prevProps) {
    if (this.state.msgId !== this.props.notification.msgId) {
      this.setState({
        message: this.props.notification.message,
        msgId: this.props.notification.msgId,
      }, () => {
        this.startTimer(this.props.notification.timeout);
      });
    }
  }

  startTimer = (timeout) => {
    this.setState({
      countDown: timeout ? timeout : DEFAULT_TIMER_COUNTDOWN,
    }, () => {
      this.timer = setInterval(this.countDownTime, DEFAULT_TIME_STEP);
    });
  };

  clearTimer = () => {
    this.setState({
      countDown: 0,
    }, () => {
      clearInterval(this.timer);
    });
  };

  countDownTime = () => {
    if (this.state.countDown > 0) {
      this.setState({
        countDown: this.state.countDown - 1,
      });
    } else {
      this.clearTimer();
    }
  };

  handleVisibility = () => {
      if (this.state.countDown > 0) {
        return `vm-leadform-notification-wrapper`;
      } else {
        return `vm-leadform-notification-wrapper hide`;
      }
  };

  render() {
    return (
      <div className={this.handleVisibility()}>
        <NotificationItem
          message={this.state.message}
        />
      </div>
    );
  }
}

export default NotificationWrapper;


